// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__7AGDW","inner":"Footer_inner__LCA3x"};